import { getConfideckSharedPackageInfo } from '@confinion/confideck-shared';
import { useContext, useEffect, useMemo } from 'react';
import { FRONTEND_VERSION } from '@config/index';
import { AuthContext, SignInContext } from '@modules/users';
import { useDocumentTitle } from '@shared/hooks';

const Dev = () => {
  const { getAccessToken } = useContext(AuthContext);
  const { organization } = useContext(SignInContext);
  const sharedPackageInfo = useMemo(() => getConfideckSharedPackageInfo(), []);

  const softwareVersion = organization?.softwareVersion ?? FRONTEND_VERSION;

  useDocumentTitle('Confideck - Dev');

  useEffect(() => {
    getAccessToken()
      .then((token) => console.log(token))
      .catch((error) => console.error(error));
  }, [getAccessToken]);

  useEffect(() => {
    console.info('Confideck shared package loaded successfully.', sharedPackageInfo);
  }, [sharedPackageInfo]);

  return (
    <div className="space-y-2 p-4 text-lg">
      <p>Confideck version: {softwareVersion}</p>
    </div>
  );
};

export default Dev;
